/* eslint-disable react/prop-types */
import React from "react";
import { Switch } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

function FormSwitch({ label, name, checked, onChange, helperText = "" }) {
  return (
    <ArgonBox mb={1.5}>
      <ArgonBox display="flex" flexDirection="column" alignItems="flex-start">
        <ArgonBox display="flex" alignItems="center" mb={1}>
          <ArgonTypography variant="button" fontWeight="medium" mr={1}>
            {label}
          </ArgonTypography>
          <Switch checked={checked} onChange={onChange} name={name} color="primary" />
        </ArgonBox>
        {helperText && (
          <ArgonTypography variant="caption" color="text" sx={{ lineHeight: 1.4, ml: 0 }}>
            {helperText}
          </ArgonTypography>
        )}
      </ArgonBox>
    </ArgonBox>
  );
}

export default FormSwitch;
